import { Loader2, UploadIcon, X } from "lucide-react";
import { SetStateAction, useEffect, useState } from "react"
import { Button } from "../ui/button.tsx";
import { useUploadPostImage } from "./api/single-post-api";

type Props = {
  postId: number,
  currentUrl: string,
  setImage: React.Dispatch<SetStateAction<string>>,
  setShowImageForm: React.Dispatch<SetStateAction<boolean>>,
}

const CustomImageForm = ({ currentUrl, postId, setShowImageForm, setImage }: Props) => {

  const [file, setFile] = useState<File | null>(null)

  const { uploadImage, isSuccess, data, isPending } = useUploadPostImage()

  useEffect(() => {

    if (isSuccess && data) {
      setImage(data.image_path)
      setShowImageForm(false)
    }

  }, [isSuccess])

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length === 1) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (file) {
      uploadImage({ postId, currentUrl, imageFile: file })
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2 size-full min-h-[400px]">
      <div className="flex items-center justify-center size-full">
        <label
          htmlFor="dropzone-file"
          className="flex flex-col items-center justify-center flex-1 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
        >
          <div className="flex flex-col items-center justify-center size-full min-h-80">
            <UploadIcon className="w-10 h-10 text-gray-400" />
            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
              <span className="font-semibold">Click to upload</span> or drag and drop
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
          </div>
          <input id="dropzone-file" type="file" className="hidden" onChange={handleFileChange} />
        </label>
      </div>
      {file && (
        <div className="animate-in slide-in-from-bottom-full flex items-center justify-between">
          <div>
            <p className="text-sm font-medium">{file.name.slice(0, 20)}...</p>
            <p className="text-xs text-muted-foreground">{(file.size / 1024).toFixed(2)} KB</p>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" type="button" className="h-7" onClick={handleRemoveFile}>
              <X />
            </Button>
            <Button
              type="submit"
              disabled={isPending}
              className="h-7">{isPending ?
                <>
                  <Loader2 className="animate-spin" /> Uploading
                </>
                : <>
                  <UploadIcon /> Upload
                </>}</Button>
          </div>
        </div>
      )}
    </form>
  )
}

export default CustomImageForm
